import { applyAlignContent } from './alignContent';
import { applyAlignItems } from './alignItems';
import { applyAlignSelf } from './alignSelf';
import { applyFlexDirection } from './flexDirection';
import { applyFlexWrap } from './flexWrap';
import { applyJustifyContent } from './justifyContent';
import { applyJustifyItems } from './justifyItems';
import { applyJustifySelf } from './justifySelf';
export const applyFlexbox = (props) => [
    ...applyAlignItems(props === null || props === void 0 ? void 0 : props.alignItems),
    ...applyAlignContent(props === null || props === void 0 ? void 0 : props.alignContent),
    ...applyJustifyItems(props === null || props === void 0 ? void 0 : props.justifyItems),
    ...applyJustifyContent(props === null || props === void 0 ? void 0 : props.justifyContent),
    ...applyFlexWrap(props === null || props === void 0 ? void 0 : props.flexWrap),
    ...applyFlexDirection(props === null || props === void 0 ? void 0 : props.flexDirection),
    ...applyJustifySelf(props === null || props === void 0 ? void 0 : props.justifySelf),
    ...applyAlignSelf(props === null || props === void 0 ? void 0 : props.alignSelf),
];
export const applyFlexboxInlineStyle = ({ flex, flexGrow, flexShrink, flexBasis, gap, order }) => {
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (flex && { flex })), (flexGrow && { flexGrow })), (flexShrink && { flexShrink })), (flexBasis && { flexBasis })), (gap && { gap })), (order && { order }));
};
